import { useAppSelector } from 'root/src/client/logic/helpers/useStore';
import { Platform } from 'root/src/shared/@types/platforms';
import { platformsToViewershipPlatforms } from 'root/src/shared/util/platformHelpers';
function useUserSelector(state) {
    var _a, _b, _c;
    return {
        authentication: (_a = state === null || state === void 0 ? void 0 : state.app) === null || _a === void 0 ? void 0 : _a.authentication,
        userData: (_b = state === null || state === void 0 ? void 0 : state.app) === null || _b === void 0 ? void 0 : _b.userData,
        stepsCompleted: (_c = state === null || state === void 0 ? void 0 : state.app) === null || _c === void 0 ? void 0 : _c.stepsCompleted,
    };
}
export function useUser() {
    return useAppSelector(useUserSelector);
}
export function useUserCreatorData() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { userData } = useUser();
    const connectedPlatforms = (_b = (_a = userData === null || userData === void 0 ? void 0 : userData.tokens) === null || _a === void 0 ? void 0 : _a.map(token => token.platform)) !== null && _b !== void 0 ? _b : [];
    const viewershipPlatforms = platformsToViewershipPlatforms(connectedPlatforms);
    return {
        averageCcv: (_c = userData === null || userData === void 0 ? void 0 : userData.creatorData) === null || _c === void 0 ? void 0 : _c.ccv,
        averageYoutubeViews: (_d = userData === null || userData === void 0 ? void 0 : userData.creatorData) === null || _d === void 0 ? void 0 : _d.averageYoutubeViews,
        averageYoutubeShortsViews: (_e = userData === null || userData === void 0 ? void 0 : userData.creatorData) === null || _e === void 0 ? void 0 : _e.averageYoutubeShortsViews,
        tiktokFollowers: (_g = (_f = userData === null || userData === void 0 ? void 0 : userData.tokens) === null || _f === void 0 ? void 0 : _f.find(token => token.platform === Platform.TikTok)) === null || _g === void 0 ? void 0 : _g.followerCount,
        //
        followerCount: (_h = userData === null || userData === void 0 ? void 0 : userData.creatorData) === null || _h === void 0 ? void 0 : _h.followerCount,
        platform: (_j = userData === null || userData === void 0 ? void 0 : userData.creatorData) === null || _j === void 0 ? void 0 : _j.platform,
        tokens: userData === null || userData === void 0 ? void 0 : userData.tokens,
        connectedPlatforms,
        viewershipPlatforms,
        creatorPoints: ((_k = userData === null || userData === void 0 ? void 0 : userData.creatorData) === null || _k === void 0 ? void 0 : _k.creatorPoints) || 0,
    };
}
